"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2186],{

/***/ 16165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41755);





var Icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var className = props.className,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      restProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"]);

  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warning */ .Kp)(Boolean(Component || children), 'Should have `component` prop or `children`.');
  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .useInsertStyles */ .C3)();
  var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()('anticon', className);
  var svgClassString = classnames__WEBPACK_IMPORTED_MODULE_1___default()({
    'anticon-spin': !!spin
  });
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _utils__WEBPACK_IMPORTED_MODULE_3__/* .svgBaseProps */ .vD), {}, {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  } // component > children


  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, innerSvgProps), children);
    }

    if (children) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warning */ .Kp)(Boolean(viewBox) || react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    return null;
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({
    role: "img"
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
});
Icon.displayName = 'AntdIcon';
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 62186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ download; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/HomePageLayout/index.tsx + 10 modules
var HomePageLayout = __webpack_require__(22647);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/download/styled.ts
var styled = __webpack_require__(22090);
;// CONCATENATED MODULE: ./src/features/download/constants.tsx

var advancedOrderbookFeatures = [
    {
        title: "Right Click for Advanced Analysis",
        content: "Klik kanan pada harga untuk menganalisa berbagai macam fitur terkini."
    },
    {
        title: "Buy From Orderbook",
        content: "Beli saham langsung di orderbook dan dot warna hijau akan muncul sebagai status order yang kamu buat."
    },
    {
        title: "Drag to Sell",
        content: "Kini menjual seluruh saham di portfolio bisa dengan cara drag Available Lot pada bagian atas ke harga yang diinginkan."
    }, 
];
var valueIcons = [
    {
        icon: "/images/value-1.svg",
        text: [
            "Aplikasi Stabil",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "dan Ringan"
        ]
    },
    {
        icon: "/images/value-2.svg",
        text: [
            "Ultra Fast",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            " Order 10ms"
        ]
    },
    {
        icon: "/images/value-3.svg",
        text: [
            "Data",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "Real Time"
        ]
    }, 
];
var valuePoint = [
    {
        text: "Complete Widget",
        subText: "Buat sendiri trading layout sesuai preferensi kamu dengan pilihan widget yang lengkap."
    },
    {
        text: "Customizable Layout",
        subText: "Add, remove, resize, atur posisi bahkan grouping widget sesuka kamu."
    },
    {
        text: "Autosave in Cloud",
        subText: "Bahkan jika kamu mengganti device, trading layout yang kamu buat tetap bisa diakses."
    }, 
];
var faq = [
    {
        title: "Bagaimana cara download aplikasi Stockbit versi desktop?",
        content: "Caranya dengan menekan salah satu tombol download untuk Mac atau Windows sesuai OS yang kamu miliki. Setelah instalasi, kamu dapat login akun Stockbit ataupun mendaftarkan sebagai user baru."
    },
    {
        title: "Apakah aplikasi Stockbit versi desktop berbayar?",
        content: "Akses aplikasi saham Stockbit versi desktop bisa digunakan secara gratis. Kamu hanya perlu log-in atau mendaftarkan akun di Stockbit."
    },
    {
        title: "Apakah tetap bisa trading saham di Stockbit versi desktop?",
        content: "Ya, kamu tetap bisa trading lebih mudah dengan layar yang lebih luas di aplikasi Stockbit versi Desktop untuk Mac dan Windows."
    }, 
];
var schemaJson = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Aplikasi Saham Stockbit versi Desktop untuk MacOs dan Windows",
    description: "Aplikasi investasi saham dengan tampilan layar yang lebih luas untuk kemudahan saat trading atau beli saham.",
    publisher: {
        "@type": "Organization",
        name: "Stockbit"
    }
};
var keyword = "aplikasi saham, aplikasi trading saham, aplikasi saham desktop, aplikasi saham windows, aplikasi saham macOS, aplikasi saham macbook, aplikasi saham online, aplikasi investasi desktop saham, download aplikasi saham desktop, aplikasi investasi saham terbaik, aplikasi saham aman.";
var metaDesc = "Aplikasi saham dengan tampilan multi monitor untuk mendukung performa trading sahammu. Stockbit tersedia desktop app untuk Windows dan MacOs. Download sekarang!";
var metaTitle = "Download Aplikasi Saham Stockbit Desktop App untuk Mac dan Windows";
var systemRequirement = {
    windows: [
        {
            key: "OS",
            value: "Windows 10 or above (64 bit)"
        },
        {
            key: "Processor",
            value: "Dual core from Intel or AMD at 2.8 GHz"
        },
        {
            key: "Memory",
            value: "16GB RAM"
        },
        {
            key: "Storage",
            value: "20GB available space"
        }, 
    ],
    mac: [
        {
            key: "OS",
            value: "MacOS 12 or above"
        },
        {
            key: "Processor",
            value: "Apple M1 or Intel Core M"
        },
        {
            key: "Memory",
            value: "8GB RAM"
        },
        {
            key: "Storage",
            value: "20GB available space"
        }, 
    ]
};

// EXTERNAL MODULE: ./src/features/download/DownloadButtons.tsx
var DownloadButtons = __webpack_require__(62486);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/features/download/Accordion.tsx




var AccordionItem = function(param) {
    var title = param.title, content = param.content;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* AccordionItemWrapper */.PW, {
        onClick: function() {
            return setOpen(!open);
        },
        active: open,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* AccordionItemContainer */.n0, {
                active: open,
                onClick: function() {
                    return setOpen(!open);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "collapsible",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "content ".concat(open ? "active" : "inactive"),
                        children: content
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: "chevron",
                src: "icon/chevron-down.svg",
                width: "32",
                height: "32"
            })
        ]
    });
};
var Accordion = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AccordionWrapper */.WL, {
        children: content.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem, {
                    title: item.title,
                    content: item.content
                })
            }, "accordion-".concat(index + 1));
        })
    });
};
/* harmony default export */ var download_Accordion = (Accordion);

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/features/download/Hero.tsx





var DownloadHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Hero */.VM, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* HeroTitle */.LR, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Title */.Dx, {
                        children: [
                            "Stockbit ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "green",
                                children: "Desktop App"
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SubTitle */.DK, {
                        children: "Pengalaman Trading Lebih Profesional dengan Aplikasi Saham versi Desktop untuk MacOS dan Windows"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButtons/* default */.Z, {
                        source: "Download Page"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ImageWithShadow */.t7, {
                className: "image-hero hero",
                marginTop: -80,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        className: "ellipse",
                        src: "/images/Ellipse.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/monitor-bezel.svg",
                                className: "image hero-bezel",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                style: {
                                    transition: "all 0.3s"
                                },
                                autoPlay: true,
                                loop: true,
                                muted: true,
                                playsInline: true,
                                className: "image video-hero",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "".concat(app/* assetPrefix */.Vc, "/homepage/desktop-hero.mp4")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "end",
                style: {
                    height: "10px",
                    paddingTop: "100px"
                }
            })
        ]
    });
};
/* harmony default export */ var Hero = (DownloadHero);

;// CONCATENATED MODULE: ./src/features/download/ValuePointIcon.tsx



var ValuePointIcon = function(param) {
    var icon = param.icon, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ValuePointIconItem */.xR, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: text
            })
        ]
    });
};
/* harmony default export */ var download_ValuePointIcon = (ValuePointIcon);

;// CONCATENATED MODULE: ./src/features/download/hooks/useResizeObserve.tsx

var useResizeObserve = function(element) {
    var ref = (0,react.useState)(0), width = ref[0], setWidth = ref[1];
    (0,react.useEffect)(function() {
        var el = document.querySelector(element);
        var observer = new ResizeObserver(function(entries) {
            window.requestAnimationFrame(function() {
                if (entries[0].contentRect.width) {
                    setWidth(entries[0].contentRect.width);
                }
            });
        });
        observer.observe(el);
        return function() {
            observer.unobserve(el);
        };
    }, []);
    return {
        width: width
    };
};
/* harmony default export */ var hooks_useResizeObserve = (useResizeObserve);

;// CONCATENATED MODULE: ./src/features/download/MultiMonitor.tsx







var MultiMonitor = function() {
    var width = hooks_useResizeObserve(".multi-monitor").width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ValueMultiMonitor */.nd, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Title */.Dx, {
                    children: [
                        "Tampilan ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "green",
                            children: " Multi Monitor"
                        }),
                        " untuk Dukung Performa Trading Sahammu"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ValuePoints */.Pu, {
                    className: "value-points-icon",
                    children: valueIcons.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(download_ValuePointIcon, {
                                icon: item.icon,
                                text: item.text
                            }, "value-icon-".concat(index + 1))
                        }, "value-icon-".concat(index + 1));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ImageWithShadow */.t7, {
                    className: " image-value image-value image-multi",
                    marginTop: -260,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            className: "ellipse",
                            src: "/images/Ellipse.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                position: "relative",
                                top: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* VideoMultiMonitor */.SB, {
                                    left: 4,
                                    marginTop: 4,
                                    width: width,
                                    autoPlay: true,
                                    loop: true,
                                    muted: true,
                                    playsInline: true,
                                    className: " video-multi-monitor",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "".concat(app/* assetPrefix */.Vc, "/homepage/left-monitor.mp4")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* VideoMultiMonitor */.SB, {
                                    right: 4,
                                    marginTop: 4,
                                    width: width,
                                    autoPlay: true,
                                    loop: true,
                                    muted: true,
                                    playsInline: true,
                                    className: " video-multi-monitor",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "".concat(app/* assetPrefix */.Vc, "/homepage/right-monitor.mp4")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/multi-monitor.svg",
                                    className: "image multi-monitor"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "end-multi",
                    style: {
                        height: "10px",
                        paddingTop: "198px"
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var download_MultiMonitor = (MultiMonitor);

;// CONCATENATED MODULE: ./src/features/download/ValuePoint.tsx


var ValuePoint = function(param) {
    var subText = param.subText, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ValuePointItem */.jx, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "subtext",
                children: subText
            })
        ]
    });
};
/* harmony default export */ var download_ValuePoint = (ValuePoint);

;// CONCATENATED MODULE: ./src/features/download/CustomLayout.tsx






var CustomLayout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ValueCustomLayout */._D, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Title */.Dx, {
                children: [
                    "Trading Saham dengan ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "green",
                        children: " Custom Layout"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "images-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/monitor-bezel.svg",
                        className: "image",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        playsInline: true,
                        className: "image-example",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: "".concat(app/* assetPrefix */.Vc, "/homepage/trading-custom-layout.mp4")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ValuePoints */.Pu, {
                className: "value-points",
                gap: 40,
                children: valuePoint.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(download_ValuePoint, {
                            text: item.text,
                            subText: item.subText
                        })
                    }, "value-point-".concat(index + 1));
                })
            })
        ]
    });
};
/* harmony default export */ var download_CustomLayout = (CustomLayout);

// EXTERNAL MODULE: ./src/features/download/desktop-analytics.ts
var desktop_analytics = __webpack_require__(53400);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/CuratorIO/stores/useCuratorFeedsStore.ts + 2 modules
var useCuratorFeedsStore = __webpack_require__(59723);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
;// CONCATENATED MODULE: ./src/features/download/ShareYourSetup.tsx











var ShareYourSetup = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCuratorFeedsStore/* default */.Z)(function(s) {
        var ref;
        return [
            ((ref = s.data) === null || ref === void 0 ? void 0 : ref.posts) || [],
            s.loadCuratorFeed
        ];
    }, shallow/* default */.Z), 2), feedPosts = ref[0], loadCuratorFeed = ref[1];
    var getPostProps = function(postIndex) {
        var ref = feedPosts[postIndex] || {}, username = ref.user_screen_name, userImgSrc = ref.user_image, src = ref.image_large, href = ref.url;
        return {
            username: username,
            userImgSrc: userImgSrc,
            src: src,
            href: href
        };
    };
    var mobilePostList = (0,react.useMemo)(function() {
        return new Array(7).fill("").map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                    width: "160px",
                    height: "160px"
                }, getPostProps(index)))
            }, index.toString());
        });
    }, [
        feedPosts
    ]);
    (0,react.useEffect)(function() {
        loadCuratorFeed();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ShareYourSetupSection */.t2, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ShareYourSetupTitle */.Iq, {
                children: [
                    "User Experience with",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "green",
                        children: "#StockbitDesktopApp"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ImageListRow */.RJ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        xs: 0,
                        lg: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ShareImgBody */.q$, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ShareImgContainer */.fN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                        width: "265px"
                                    }, getPostProps(0))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ShareColumnContainer */.GQ, {
                                        width: "315px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                                height: "192px"
                                            }, getPostProps(1))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                                height: "196px"
                                            }, getPostProps(2)))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ShareColumnContainer */.GQ, {
                                        width: "256px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                                height: "151px"
                                            }, getPostProps(3))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                                height: "238px"
                                            }, getPostProps(4)))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ShareColumnContainer */.GQ, {
                                        width: "265px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                                height: "272px"
                                            }, getPostProps(6))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImageItem */.vE, (0,_object_spread/* default */.Z)({
                                                height: "116px"
                                            }, getPostProps(7)))
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        xs: 24,
                        lg: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* MobileImageList */.P5, {
                            children: mobilePostList
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/desktop/trading-setup",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* SeeGallery */.Sz, {
                    children: [
                        "See All",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: ChevronDownSvg/* default */.Z,
                            style: {
                                transform: "rotate(-90deg)"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var download_ShareYourSetup = (ShareYourSetup);

;// CONCATENATED MODULE: ./src/features/download/index.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/interactive-supports-focus */ 










// TEMPORARY HIDDEN CONTENT IS NOT YET AVAILABLE
// import MobileAdvanced from './MobileAdvanced';
// import Advanced from './AdvancedOrderbook';


var DownloadPage = function() {
    (0,react.useEffect)(function() {
        // need time to get clevertap id to send event
        setTimeout(function() {
            desktop_analytics/* DesktopAppDownloadAnalytics.onDesktopAppLandingPage */.E.onDesktopAppLandingPage();
        }, 300);
    }, []);
    var ref = (0,react.useState)("windows"), openTab = ref[0], setOpenTab = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout["default"], {
        theme: "dark",
        hideStartInvesting: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                description: metaDesc,
                title: metaTitle,
                schemaJson: schemaJson,
                keywords: keyword
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(download_MultiMonitor, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(download_CustomLayout, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(download_ShareYourSetup, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "separator-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "separator"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fade"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FAQContainer */.US, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Title */.Dx, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "green",
                                        children: "Frequently"
                                    }),
                                    " Asked Question"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(download_Accordion, {
                                content: faq
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* DownloadSection */.th, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* DownloadSectionLeft */.ai, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Title */.Dx, {
                                        children: [
                                            "Stockbit ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "green",
                                                children: "Desktop App"
                                            }),
                                            " Bisa Diakses untuk Mac dan Windows"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButtons/* default */.Z, {
                                        source: "Download Page"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* SystemRequirementWrapper */.ZI, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "title",
                                        children: "Recommended Requirements"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tabs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return setOpenTab("windows");
                                                },
                                                className: "".concat(openTab === "windows" && "active", " tab-head"),
                                                role: "button",
                                                children: "Windows"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return setOpenTab("mac");
                                                },
                                                className: "".concat(openTab === "mac" && "active", " tab-head"),
                                                role: "button",
                                                children: "MacOS"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tab-content",
                                        children: systemRequirement[openTab].map(function(x, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tab-content-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "key",
                                                        children: [
                                                            x.key,
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: x.value
                                                    })
                                                ]
                                            }, "system-".concat(index + 1));
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var download = (DownloadPage);


/***/ }),

/***/ 68861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronDownSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M4 6l4 4 4-4"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronDownSvg);


/***/ })

}]);